import {Box, Flex, Heading, HStack, Text, useMediaQuery, VStack} from "@chakra-ui/react";
import {ReactComponent as Vertical} from "../../../../assets/icons/Empty_Vertical_Container.svg";
import {ReactComponent as VerticalMobile} from "../../../../assets/icons/Empty_Vertical_Container_mobile.svg";
import {ReactComponent as QrCode} from "../../../../assets/icons/qr_code.svg";
import {ReactComponent as CopyIcon} from "../../../../assets/icons/copy-alt.svg";
import {InputLabel, StyledButton} from "../../../../components";


export const ConfirmAddress = ({cancelSteps, addStep, user, isMobile}) => {
    const [isSmallerThan1100] = useMediaQuery("(max-width: 1100px)")

    return (
        <Flex
            flexDirection={'column'}
            w={'full'}
            gap={'16px'}
            alignItems={'start'}>
            <Flex
                w={'full'}
                gap={'16px'}
                alignItems={'start'}>
                <Box>
                    {isMobile ? <VerticalMobile /> : <Vertical />}
                </Box>
                <Box
                    w={'full'}>
                    <Box>
                        <Text fontSize={isMobile ? 'body.md':'body.lg'} mb={isMobile ? '16px':'32px'}>Crypto</Text>
                        <InputLabel
                            w={'full'}
                            h={isMobile ? '40px':'56px'}
                            border={'none'}
                            bg={'#23262F'}/>
                    </Box>
                    <Box mt={isMobile ? '35px':'84px'}>
                        <Text fontSize={isMobile ? 'body.md':'body.lg'} mb={isMobile ? '16px':'32px'}>Network</Text>
                        <InputLabel
                            w={'full'}
                            h={isMobile ? '40px':'56px'}
                            border={'none'}
                            bg={'#23262F'}/>
                    </Box>
                    <Box mt={isMobile ? '40px':'84px'}>
                        <Text fontSize={isMobile ? 'body.md':'body.lg'} mb={isMobile ? '16px':'32px'}>Amount</Text>
                        <InputLabel
                            h={isMobile ? '40px':'56px'}
                            w={'full'}
                            border={'none'}
                            bg={'#23262F'}/>
                        <Text color={'#777E90'} fontSize={'body.sm'}>Expected Arrival: 2min 50sec</Text>
                    </Box>
                </Box>
            </Flex>
            <VStack
                pl={isMobile ? '0' : '50px'}
                mt={isMobile ? '20px' :'77px'}
                align={'start'}
                w={'full'}
                gap={isMobile ? '16px' : '32px'}>
                <Heading fontSize={isMobile ? 'body.md' : 'heading.xl'}>
                    Copy Wallet Address
                </Heading>
                <Box
                    w={'full'}
                    border={'1px solid #23262F'}
                    borderRadius={'16px'}
                    p={isSmallerThan1100 ? '16px' : '32px 67px'}
                    bg={'#18191D'}>
                    <HStack
                        flexDirection={isMobile ? 'column' : 'row'}
                        gap={'32px'}>
                        <Box>
                            <Heading color={'#F4F5F6'} fontSize={isMobile ? 'body.md' : 'heading.xl'}>
                                Toncoin(TON) address is published!
                            </Heading>
                            <Text color={'#B1B5C3'} fontSize={isMobile ? 'body.xs' : 'body.md'}>
                                Please use the address below to deposit your cryptocurrency using the TONCOIN network.
                                You can either copy the address or scan the QR code for convenience.
                            </Text>
                        </Box>
                        <Box>
                            <QrCode/>
                        </Box>
                    </HStack>
                    <HStack
                        mt={'16px'}
                        gap={'20px'}
                        px={'16px'}
                        h={isMobile ? '40px':'48px'}
                        justifyContent={'space-between'}
                        borderRadius={'8px'}
                        bg={'#1C1E24'}>
                        <Text fontSize={isMobile ? 'body.xs' : 'body.md'}>TPdBs4gzVawph92jsR2toaqdBs4gzVwph92j2t</Text>
                        {
                            isMobile ? <CopyIcon width={'12px'}/>
                                : <StyledButton
                                    w={'77px'}
                                    leftIcon={<CopyIcon width={'12px'}/>}
                                    fontSize={'body.xs'}
                                    h={'32px'}
                                    bg={'#23262F'}>
                                    copy
                                </StyledButton>
                        }

                    </HStack>
                </Box>
                <HStack
                    flexDirection={isMobile ? 'column' : 'row'}
                    gap={'16px'}
                    w={'full'}>
                    <StyledButton
                        onClick={cancelSteps}
                        bg={'#6F41D240'}
                        h={isMobile ? '40px' : '56px'}
                        w={'full'}>
                        Cancel
                    </StyledButton>
                    <StyledButton
                        onClick={addStep}
                        h={isMobile ? '40px' : '56px'}
                        w={'full'}>
                        Next
                    </StyledButton>
                </HStack>
            </VStack>
        </Flex>
    )
}